<template>
  <v-container class="mx-auto pl-6" fluid>
    <v-row justify="space-between">
      <v-col cols="4" class="break-point-custom-arquivos-dados first-v-col-diretorios pl-0 pr-2 pt-0">
        <base-material-card color="primary" icon="mdi-folder-network-outline" inline class="ml-0">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">Diretórios</div>
          </template>

          <v-btn
            v-if="userIsAdmin"
            id="btn-novo-grupo-arquivos"
            color="success"
            elevation="1"
            class="my-5"
            relative
            text
            medium
            @click="$router.push(`/grupos-arquivos/`)"
          >
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            NOVO GRUPO
          </v-btn>

          <v-btn
            id="btn-arquivos-tratados"
            color="blue"
            elevation="1"
            class="my-5"
            relative
            text
            medium
            @click="$router.push({ name: 'Arquivos Tratados' })"
          >
            <v-icon left sie="30px">mdi-file-cog-outline</v-icon>
            ARQUIVOS TRATADOS
          </v-btn>

          <v-row v-if="loadingTreeView" class="my-4" align="center" justify="center">
            <v-progress-circular indeterminate width="2" />
          </v-row>
          <v-treeview
            v-show="!loadingTreeView"
            :items="directoryOrganization"
            :active.sync="active"
            :open.sync="openTabs"
            :open-all="true"
            activatable
            item-key="id"
            open-on-click
            :multiple-active="false"
            :transition="true"
          >
            <template v-slot:prepend="{ item, open, leaf }">
              <v-icon v-if="leaf" :key="item.id + directoriesWithFiles[item.id]">
                {{ directoriesWithFiles[item.id] == true ? 'mdi-check-bold' : 'mdi-folder' }}
              </v-icon>
              <v-icon v-else>
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
            <template v-slot:label="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" class="text-truncate" v-on="on">
                    {{ item.name }}
                  </div>
                </template>
                <span>{{ item.name }}</span>
              </v-tooltip>
            </template>
          </v-treeview>
        </base-material-card>
      </v-col>
      <v-col cols="8" class="break-point-custom-arquivos-dados px-0 py-0">
        <base-material-card color="primary" icon="mdi-file-outline" inline class="px-5 py-3">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
              Arquivos
              <template v-if="getDateFormattedCard">
                <v-icon color="primary" class="mb-1 mx-1">mdi-arrow-right-thick</v-icon>
                {{ getDateFormattedCard }}
                <v-icon color="primary" class="mb-1 mx-1">mdi-arrow-right-thick</v-icon>
                {{ selectedGroupObj.grupo }}
              </template>
            </div>
          </template>

          <!-- v-alert -->
          <v-row class="mx-auto my-8" align="center" no-gutters>
            <v-col v-if="active.length == 0" cols="12">
              <v-alert dense outlined type="info" color="blue" class="mb-0 px-1 py-1">
                Selecione um diretório ao lado para poder realizar os envios
              </v-alert>
            </v-col>
            <!-- Input de arquivos -->
            <v-col v-if="active.length > 0" cols="12">
              <div class="dropbox">
                <input type="file" multiple class="input-file" title=" " @change="filesChange($event)" />

                <v-row justify="center" align="center" class="py-4">
                  <v-icon color="primary" size="96">mdi-cloud-upload-outline</v-icon>
                </v-row>
                <p class="display-2 pb-4 text-center">Clique para adicionar ou arraste e solte os arquivos</p>
              </div>
            </v-col>
          </v-row>

          <general-progress-bars
            class="mb-11 mt-11"
            :items="uploadProgressData"
            prefixText="Enviando"
            suffixProperty="name"
            :includeHashOnText="false"
            :truncateText="true"
          />

          <!-- Listagem de arquivos para upload -->
          <arquivos-dados-upload-queue
            :files.sync="files"
            :uploadProgressData.sync="uploadProgressData"
            :active="active"
            @rechargeUploadedFiles="getArquivosFromSelectedGroup()"
          />

          <general-progress-bars class="mb-8 mt-8" :items="downloadProgressData" prefixText="Baixando Arquivo" />

          <!-- Listagem de arquivos enviados -->
          <arquivos-dados-uploaded-files-list
            v-if="active.length > 0"
            :items.sync="items"
            :downloadProgressData.sync="downloadProgressData"
            :loading="loading"
            :active="active"
            @rechargeUploadedFiles="getArquivosFromSelectedGroup()"
          />
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ArquivosDadosService from '@/services/ArquivosDadosService.js';
  import GruposArquivosService from '@/services/GruposArquivosService.js';
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
  import randomString from '@/utils/generateRandomString.js';
  import dayjs from 'dayjs';

  export default {
    name: 'ArquivosDadosIndex',

    components: {
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      ArquivosDadosUploadQueue: () => import('@/components/arquivosDados/ArquivosDadosUploadQueue.vue'),
      ArquivosDadosUploadedFilesList: () => import('@/components/arquivosDados/ArquivosDadosUploadedFilesList.vue')
    },

    mixins: [DateFormatterMixins],

    data: () => ({
      active: [],
      openTabs: [],
      directoryOrganization: [],
      directoriesWithFiles: {},
      items: [],
      gruposArquivos: [],
      files: [],
      loading: false,
      loadingTreeView: true,
      downloadProgressData: {},
      uploadProgressData: {}
    }),

    computed: {
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      getDateFormattedCard() {
        return this.active.length ? this.formatMonth(this.active[0].substring(0, 10)) : '';
      },
      user() {
        return this.$store.getters.getUser;
      },
      selectedAno() {
        return this.active.length ? this.active[0].split('-')[0] : '';
      },
      selectedMes() {
        return this.active.length ? this.active[0].split('-')[1] : '';
      },
      selectedGroupId() {
        return this.active.length ? this.active[0].split('-')[2] : '';
      },
      selectedGroupObj() {
        const idx = this.gruposArquivos.findIndex((g) => g.id == this.selectedGroupId);
        return this.active.length ? this.gruposArquivos[idx] : {};
      },
      selectedGroupPrazo() {
        const dia = String(this.selectedGroupObj.dia_envio);
        return this.active.length ? `${dia.padStart(2, '0')}/${this.getDateFormattedCard}` : '';
      },
      uploadInProgress() {
        return Object.values(this.uploadProgressData).length > 0;
      }
    },

    async mounted() {
      this.getAnoMesGrupoWithFiles();
      await this.getGruposArquivos();
      this.mountItemsDirectory();
    },

    methods: {
      mountItemsDirectory() {
        let currentYear = dayjs().format('YYYY');

        // Monta a arvore de anos-meses-grupo dos ultimos 3 anos
        for (let ano = currentYear; ano > currentYear - 3; ano--) {
          this.directoryOrganization.push({
            id: ano,
            name: ano,
            disabled: false,
            children: Array(12)
              .fill()
              .map((x, mes) => {
                return {
                  id: `${ano}-${mes + 1}`,
                  name: String(mes + 1).padStart(2, '0'),
                  children: this.gruposArquivos.map((grupo) => {
                    return {
                      id: `${ano}-${mes + 1}-${grupo.id}`,
                      name: grupo.grupo
                    };
                  })
                };
              })
          });
        }

        this.loadingTreeView = false;
        this.openTabs = [currentYear, dayjs().format('YYYY-M')];
      },
      getGruposArquivos() {
        return GruposArquivosService.getGruposArquivosAtivos()
          .then((res) => {
            this.gruposArquivos = res.data.grupos;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar Grupos de Arquivos.', '', { position: 'topRight' });
          });
      },
      getAnoMesGrupoWithFiles() {
        GruposArquivosService.getAnoMesGrupoWithFiles()
          .then((res) => {
            res.data.anoMesGrupo.forEach((el) => {
              this.directoriesWithFiles[`${el.ano}-${el.mes}-${el.grupoId}`] = true;
            });
          })
          .catch((err) => {
            console.error(err);
          });
      },
      getArquivosFromSelectedGroup() {
        if (!this.active.length) return; // Cancela caso não tenha nenhum grupo selecionado

        this.items = [];
        this.loading = true;

        const ano = this.selectedAno;
        const mes = this.selectedMes;
        const grupoId = this.selectedGroupId;
        const anoMesGrupoId = `${ano}-${mes}-${grupoId}`;

        ArquivosDadosService.getArquivosByAnoMesAndGrupoId(ano, mes, grupoId)
          .then((res) => {
            let auxArray = [];
            res.data.arquivos.forEach((arquivo) => {
              auxArray.push({
                id: arquivo.id,
                nome: arquivo.arquivo,
                size: arquivo.tamanho,
                enviado_por: arquivo.usuario.nome,
                created: dayjs(arquivo.created).format('DD/MM/YYYY HH:mm'),
                importado: arquivo.importado
              });
            });

            this.items = auxArray;

            this.$set(this.directoriesWithFiles, anoMesGrupoId, this.items.length > 0);
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error(`Erro ao recuperar arquivos.`, '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      filesChange(event) {
        const fileList = event.target.files;

        if (!fileList.length) return;

        for (const file of fileList) {
          this.files.push({
            id: randomString(30),
            name: file.name,
            size: file.size,
            fileObj: file
          });
        }

        event.target.value = '';
      }
    },

    watch: {
      active() {
        this.getArquivosFromSelectedGroup();
      },
      uploadInProgress() {
        // Se houver algum upload em progresso, desativa a treeview.
        for (const directory of this.directoryOrganization) {
          directory.disabled = this.uploadInProgress;
        }
      }
    }
  };
</script>

<style>
  .v-alert__icon {
    align-self: center;
  }

  .first-v-col-diretorios {
    min-width: 195px !important;
  }

  @media screen and (max-width: 826px) {
    .break-point-custom-arquivos-dados {
      max-width: 100% !important;
      -ms-flex: 0 0 100% !important;
      flex: 0 0 100% !important;
      margin-left: 0px !important;
    }
  }
</style>

<style lang="scss">
  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -3px;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    z-index: 111;
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
</style>
